export default class ImageEditorCtrl {

    constructor($rootScope, ImageBank) {

        this.imageBankRepo = ImageBank;

        this._rootScope = $rootScope;
        this._rootScope.$on('event:upload.image.to.edit', (event, data) => {
            this.createNewTUIInstance(data);
        });
    }

    createNewTUIInstance(data) {

        if (this.tuiInstance) this.tuiInstance.destroy();

        this.data = data;

        $('body').addClass('tui-mode');
        this.tuiEl = $('.tui');

        this.tuiEl.fadeIn();

        this.tuiInstance = new tui.ImageEditor('#image-editor', {
            includeUI: {
                loadImage: {
                    path: `/img_proxy?absolutePath=${this.data.imageURL}`,
                    name: 'img'
                },
                theme: this.getTheme(),
                itemMenu: 'filter',
                menu: ['crop', 'flip', 'draw', 'shape', 'icon', 'text', 'mask', 'filter'],
                menuBarPosition: 'left'
            }
        });
        this.instanceId = (new Date).getTime();


        // Fix drawing icons
        this.tuiInstance._graphics.registerPaths({
            'icon-arrow': 'M40 12V0l24 24-24 24V36H0V12h40z',
            'icon-arrow-2': 'M49,32 H3 V22 h46 l-18,-18 h12 l23,23 L43,50 h-12 l18,-18  z ',
            'icon-arrow-3': 'M43.349998,27 L17.354,53 H1.949999 l25.996,-26 L1.949999,1 h15.404 L43.349998,27  z ',
            'icon-star': 'M35,54.557999 l-19.912001,10.468 l3.804,-22.172001 l-16.108,-15.7 l22.26,-3.236 L35,3.746 l9.956,20.172001 l22.26,3.236 l-16.108,15.7 l3.804,22.172001  z ',
            'icon-star-2': 'M17,31.212 l-7.194,4.08 l-4.728,-6.83 l-8.234,0.524 l-1.328,-8.226 l-7.644,-3.14 l2.338,-7.992 l-5.54,-6.18 l5.54,-6.176 l-2.338,-7.994 l7.644,-3.138 l1.328,-8.226 l8.234,0.522 l4.728,-6.83 L17,-24.312 l7.194,-4.08 l4.728,6.83 l8.234,-0.522 l1.328,8.226 l7.644,3.14 l-2.338,7.992 l5.54,6.178 l-5.54,6.178 l2.338,7.992 l-7.644,3.14 l-1.328,8.226 l-8.234,-0.524 l-4.728,6.83  z ',
            'icon-polygon': 'M3,31 L19,3 h32 l16,28 l-16,28 H19  z ',
            'icon-location': 'M24 62C8 45.503 0 32.837 0 24 0 10.745 10.745 0 24 0s24 10.745 24 24c0 8.837-8 21.503-24 38zm0-28c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z',
            'icon-heart': 'M49.994999,91.349998 l-6.96,-6.333 C18.324001,62.606995 2.01,47.829002 2.01,29.690998 C2.01,14.912998 13.619999,3.299999 28.401001,3.299999 c8.349,0 16.362,5.859 21.594,12 c5.229,-6.141 13.242001,-12 21.591,-12 c14.778,0 26.390999,11.61 26.390999,26.390999 c0,18.138 -16.314001,32.916 -41.025002,55.374001 l-6.96,6.285  z ',
            'icon-bubble': 'M44 48L34 58V48H12C5.373 48 0 42.627 0 36V12C0 5.373 5.373 0 12 0h40c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12h-8z'
        });

        this.removeColorFilterTresholdLabel();
        this.removeWhiteSection();

        this.cancelTUIImageBtn = $('.tui-image-editor-header-buttons .tui-image-editor-load-btn').parent();
        this.cancelTUIImageBtn
            .html('Close')
            .on('click', this.closeTUIInstance.bind(this));

        this.saveImageBtn = $(this.tuiInstance.ui._els.download);
        this.saveImageBtn
            .html('Save')
            .on('click', this.saveImage.bind(this));

        this.colorPickerWrapper = $('.color-picker-control');
        this.colorPickerWrapper
            .on('click', this.stopEventPropagation);

        this.filterControls = this.tuiInstance.ui.filter.checkedMap;

        this.resetButton = $(this.tuiInstance.ui._els.reset);
        this.resetButton
            .on('click', this.disableNonActiveCheckboxes.bind(this));
    };

    closeTUIInstance() {
        this.cancelTUIImageBtn.off('click', this.closeTUIInstance);
        this.saveImageBtn.off('click', this.saveImage);
        this.colorPickerWrapper.off('click', this.stopEventPropagation);
        this.resetButton.off('click', this.disableNonActiveCheckboxes);
        this.tuiEl.fadeOut();
        $('body').removeClass('tui-mode');
    };

    saveImage($event) {
        $event.stopImmediatePropagation();

        this.saveImageBtn
            .html('Saving...')
            .attr('disabled', true);

        this.tuiInstance.ui.crop.actions.cancel();
        this.tuiInstance.ui.changeMenu('filter');

        const newURL = this.tuiInstance.toDataURL();
        const directory = this.data.directory ? this.data.directory : 0;
        const data = angular.copy(this.data);
        const oldInstanceId = this.instanceId;

        this.imageBankRepo.moveToS3(newURL, directory).then(newImage => {
            this._rootScope.$broadcast('imageBank:updateUI');
            this._rootScope.$broadcast('event:updateImage', {
                newImage: newImage['publicPath'],
                imageIndex: data.imageIndex
            });
            if (oldInstanceId === this.instanceId) this.closeTUIInstance();
        }).catch(err => {
            this.saveImageBtn
                .html('Save')
                .removeAttr('disabled');
        });
    };

    stopEventPropagation($event) {
        $event.stopImmediatePropagation();
        return false;
    }

    disableNonActiveCheckboxes($event) {
        Object.entries(this.filterControls).map(([key, control]) => {
            if (control.checked) {
                control.checked = false;
                $(control).closest('.tui-image-editor-checkbox-group').addClass('tui-image-editor-disabled');
            }
        });
    }

    removeColorFilterTresholdLabel() {
        this.colorFilterRange = $('#tie-colorfilter-threshole-range');
        this.colorFilterRange
            .prev()
            .remove();
        this.colorFilterRange
            .closest('.tui-image-editor-newline')
            .removeClass('tui-image-editor-newline')
            .prev()
            .removeClass('tui-image-editor-newline');
    }

    removeWhiteSection() {
        this.removeWhiteBlock = $('#tie-remove-white').closest('li.tui-image-editor-submenu-align');
        this.removeWhiteBlock
            .hide()
            .prev()
            .hide();
    }

    getTheme() {
        return {
            'common.bi.image': 'img/tui/rule-logo-for-tui.svg',
            'common.bisize.width': '251px',
            'common.bisize.height': '21px',
            'common.backgroundImage': './img/tui/bg.png',
            'common.backgroundColor': '#fff',
            'common.border': '1px solid #c1c1c1',

            // header
            'header.backgroundImage': 'none',
            'header.backgroundColor': 'transparent',
            'header.border': '0px',

            // load button
            'loadButton.backgroundColor': '#fff',
            'loadButton.border': '1px solid #ddd',
            'loadButton.color': '#222',
            'loadButton.fontFamily': '\'Noto Sans\', sans-serif',
            'loadButton.fontSize': '12px',

            // download button
            'downloadButton.backgroundColor': '#fdba3b',
            'downloadButton.border': '1px solid #fdba3b',
            'downloadButton.color': '#fff',
            'downloadButton.fontFamily': '\'Noto Sans\', sans-serif',
            'downloadButton.fontSize': '12px',

            // main icons
            'menu.normalIcon.path': 'img/tui/icon-d.svg',
            'menu.normalIcon.name': 'icon-d',
            'menu.activeIcon.path': 'img/tui/icon-b.svg',
            'menu.activeIcon.name': 'icon-b',
            'menu.disabledIcon.path': 'img/tui/icon-a.svg',
            'menu.disabledIcon.name': 'icon-a',
            'menu.hoverIcon.path': 'img/tui/icon-c.svg',
            'menu.hoverIcon.name': 'icon-c',
            'menu.iconSize.width': '24px',
            'menu.iconSize.height': '24px',

            // submenu primary color
            'submenu.backgroundColor': 'transparent',
            'submenu.partition.color': '#e5e5e5',

            // submenu icons
            'submenu.normalIcon.path': 'img/tui/icon-d.svg',
            'submenu.normalIcon.name': 'icon-d',
            'submenu.activeIcon.path': 'img/tui/icon-b.svg',
            'submenu.activeIcon.name': 'icon-b',
            'submenu.iconSize.width': '32px',
            'submenu.iconSize.height': '32px',

            // submenu labels
            'submenu.normalLabel.color': '#858585',
            'submenu.normalLabel.fontWeight': 'normal',
            'submenu.activeLabel.color': '#000',
            'submenu.activeLabel.fontWeight': 'normal',

            // checkbox style
            'checkbox.border': '1px solid #ccc',
            'checkbox.backgroundColor': '#fff',

            // rango style
            'range.pointer.color': '#333',
            'range.bar.color': '#ccc',
            'range.subbar.color': '#606060',

            'range.disabledPointer.color': '#d3d3d3',
            'range.disabledBar.color': 'rgba(85,85,85,0.06)',
            'range.disabledSubbar.color': 'rgba(51,51,51,0.2)',

            'range.value.color': '#000',
            'range.value.fontWeight': 'normal',
            'range.value.fontSize': '11px',
            'range.value.border': '0',
            'range.value.backgroundColor': '#f5f5f5',
            'range.title.color': '#000',
            'range.title.fontWeight': 'lighter',

            // colorpicker style
            'colorpicker.button.border': '0px',
            'colorpicker.title.color': '#000'

        };
    }


}
